<template>
    <section class="section">
        <div class="container is-fluid">
            <b-button type="is-info" @click="backClicked">Torna alla mappa</b-button>
            <br/><br/>

            <h1 class="title">Riconoscimenti</h1>
            <p>App creata da <a target="_blank" rel="noopener" href='https://www.linkedin.com/in/walter-simoncini-a77508137/'>Walter Simoncini</a></p>
            <p>Ringraziamenti speciali a <a target="_blank" rel="noopener" href='https://www.instagram.com/beatrice_poletti/'>Beatrice Poletti</a></p>
            <br />
            <h2 class="subtitle">
                Dati
            </h2>

            <p>COVID-19: ATS Montagna (via PiùValliTV)</p>
            <p>Comuni: <a target="_blank" rel="noopener" href='https://umap.geonue.com/en/map/confini-e-dati-statistici-dei-comuni-ditalia_297#6/42.131/14.897'>Ciro Spataro</a></p>       
        </div>
    </section>
</template>

<script>

export default {
  name: "Credits",
  methods: {
      backClicked () {
          this.$router.push('/');
      }
  }
};

</script>

<style>
</style>